import address from './address';
import address_port from './addressPort';
import notifying_action_groups from './notification_emails';
import country from './country';
import coldstore from './coldstore';
import cold_store_storage_fee from './coldStoreStorageFee';
import config_value from './config';
import contact from './contact';
import fdr_item from './FDRItem';
import fdr_rate from './FDRRate';
import fec from './fec';
import finance_factoring from './finance_factoring';
import form_fields from './formFields';
import freight_rate from './freightRate';
import grinder from './grinder';
import input_product from './inputProduct';
import interest from './interest';
import load_size from './loadSize';
import organisation from './organisation';
import output_product from './outputProduct';
import po_series from './poSeries';
import packer from './packer';
import packer_plant from './packerPlant';
import port from './port';
import shipping_line from './shippingLine';
import contract from './strategy';
import contract_price from './strategyPrice';
import strategy_type from './strategyType';
import transporter from './transporter';
import unit from './unit';
import voyage_leg from './voyageLeg';
import article_regions from './articleRegions';
import end_users from './endUsers';
import package_weight from './packageWeight';
import business_group from './businessGroup';
import specification from './specification';

const schema = [
  ...grinder,
  ...packer_plant,
  ...packer,
  ...input_product,
  ...output_product,
  ...organisation,
  ...unit,
  ...notifying_action_groups,
  ...address,
  ...address_port,
  ...contact,
  ...form_fields,
  ...po_series,
  ...port,
  ...coldstore,
  ...config_value,
  ...transporter,
  ...load_size,
  ...shipping_line,
  ...voyage_leg,
  ...fec,
  ...contract,
  ...contract_price,
  ...strategy_type,
  ...freight_rate,
  ...article_regions,
  ...end_users,
  ...package_weight,
  ...business_group,
  ...country,
  ...specification,
];

export default schema;
